var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnhappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 18.8327C5.73096 18.8327 2 15.1017 2 10.4993C2 5.89697 5.73096 2.16602 10.3333 2.16602C14.9357 2.16602 18.6667 5.89697 18.6667 10.4993C18.6667 15.1017 14.9357 18.8327 10.3333 18.8327ZM10.3333 17.166C14.0153 17.166 17 14.1813 17 10.4993C17 6.81745 14.0153 3.83268 10.3333 3.83268C6.65143 3.83268 3.66667 6.81745 3.66667 10.4993C3.66667 14.1813 6.65143 17.166 10.3333 17.166Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58333 7.49935C8.27369 7.49935 8.83333 8.05902 8.83333 8.74935C8.83333 9.43968 8.27369 9.99935 7.58333 9.99935C6.89298 9.99935 6.33333 9.43968 6.33333 8.74935C6.33333 8.05902 6.89298 7.49935 7.58333 7.49935ZM13.4167 7.49935C14.107 7.49935 14.6667 8.05902 14.6667 8.74935C14.6667 9.43968 14.107 9.99935 13.4167 9.99935C12.7263 9.99935 12.1667 9.43968 12.1667 8.74935C12.1667 8.05902 12.7263 7.49935 13.4167 7.49935Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5838 13.0303C12.8217 12.1923 11.7226 11.6663 10.5006 11.6663C9.27858 11.6663 8.17948 12.1923 7.41732 13.0303L8.20479 13.7464C8.86308 13.4851 9.65224 13.333 10.5006 13.333C11.3489 13.333 12.1381 13.4851 12.7963 13.7464L13.5838 13.0303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhappy);
export default __webpack_public_path__ + "static/media/unhappy.7dceea6a214bc7060d3d15bd2fcea97d.svg";
export { ForwardRef as ReactComponent };